const scrollProps = {
    containerId: "backStagePanel",
    spy: true,
    smooth: true,
    duration: 500,
    offset: -88
};
export default scrollProps;